import {addDisposer, applySnapshot, getRoot, types} from 'mobx-state-tree';
import {reaction} from 'mobx'
import Order from './Order';
import Product from './Product';
import Address from './Address';
import axios from 'axios';

let hubConnection = null;

if (typeof window !== "undefined") {
    //import { hubConnection } from 'signalr-no-jquery';
    var signalr = require('signalr-no-jquery');
    hubConnection = signalr.hubConnection;
}

export default types.model('OrderStore',
    {

        Basket: types.maybeNull(Order),

        Orders: types.optional(types.array(Order), []),
        Addresses: types.optional(types.array(Address), []),
        activeOrder: types.maybeNull(types.reference(Order)),
        Product: types.maybeNull(Product)

    }).views(self => ({

    //get BasketIdentifier() {
    //    console.debug("updating cookie");
    //    return self.basketCookie.value;
    //},


    get navigation() {
        return getRoot(self).navigation;
    },


    get account() {
        return getRoot(self).account;
    },
    get analytics() {
        return getRoot(self).analytics;
    },


    get useBasket() {
        return self.navigation.isD2C;
    }
}))
    .volatile(self => ({

        connection: null,
        hubProxy: null
    }))
    .actions(self => {

        return {
            afterCreate() {
                // Server?
                const serverRender = typeof window === 'undefined';

                //!serverRender && console.debug("orderstore - aftercreate");

                if (self.Basket) {
                    self.activeOrder = self.Basket;
                }

                if (!serverRender) {

                    self.connection = hubConnection();
                    self.hubProxy = self.connection.createHubProxy("orderHub");

                    addDisposer(self,
                        reaction(() => ({
                            useBasket: self.useBasket
                        }), () => {
                            if (self.useBasket) {
                                // disconnect signalr
                                self.disconnectSignalR();
                                self.getBasket();
                            } else {
                                self.connectSignalR();
                            }
                            console.debug("reaction:", self.useBasket);
                        }, {
                            delay: 200
                        })
                    )


                    // Start up signalR

                    self.connection.stateChanged(change => {
                        //console.debug("SignalR:", change);
                    });


                    self.connection.disconnected(() => {
                        console.debug('SignalR: Disconnected');
                        if (!self.useBasket) {
                            setTimeout(() => {
//                               console.debug('SignalR: Re-start');
                                self.connectSignalR();
                            }, 5000);
                        }
                    });

                    self.connection.reconnected(() => {
                       console.debug('SignalR: Reconnected');
                        // Todo: update active Order id...

                        if (self.activeOrder && !self.Basket) {
                            self.activeOrder.SetUpdateInProgress();
                            self.getOrder(self.activeOrder.OrderGuid);
                        }
                    });


                    // Define methods
                    self.hubProxy.on("notifyOrderUpdate",
                        data => {
                            if (self.activeOrder && self.activeOrder.OrderGuid === data.OrderGuid) {
                                if(data.Order) {
                                    applySnapshot(self.activeOrder, data.Order);
                                    console.debug("notifyOrderUpdate: snapshotApplied");
                                }
                                else {
                                    console.debug("notifyOrderUpdate: no shapshot avaialble");
                                }
                                
                            }
                            console.debug("notifyOrderUpdate:", data);
                        });

                    self.hubProxy.on("notifyOrderUpdateInProgress",
                        data => {
                            // data = orderGuid
                            if (self.activeOrder && data === self.activeOrder.OrderGuid) {
                                self.activeOrder.SetUpdateInProgress();
                            }
                            console.debug("notifyOrderUpdateInProgress:", data);
                        });

                    //console.debug("SignalR", self.connection);


                    if (self.useBasket) {
                        console.debug("Attach Basket");
                        self.getBasket();
                    } else {
                        self.connectSignalR();
                        console.debug("Starting SignalR - finished");
                    }

                }
            },
            afterAttach() {
                //  console.log("orderstore-attach")
            },

            async setOrders(orders) {
                await applySnapshot(self.Orders, orders);
                // if (self.activeOrder !== null) {
                //      await self.getOrder(self.activeOrder.OrderGuid);
                //  }
            },

            setAddresses(addresses) {
                self.Addresses = addresses;
            },


            async connectSignalR() {
                await self.connection.start().then(() => {
                    if (self.activeOrder && !self.Basket) {
                        self.getOrder(self.activeOrder.OrderGuid, true);
                    }
                });
            },


            disconnectSignalR() {
                self.connection.stop();
                console.debug("disconectSignalR")
            },


            async fetchOrders() {
                if (!self.navigation.getCustomerId()) {
                    return;
                }
                //self.activeOrder = null;
                //self.Orders = [];

                const res = await self.request("/Umbraco/Api/ActorOrder/All",
                    {
                        CustomerId: self.navigation.getCustomerId(),
                        SiteId: self.navigation.SiteId,
                        OrderGuid: (self.activeOrder && self.activeOrder.OrderGuid) ? self.activeOrder.OrderGuid : null
                    });
                
                if(!res) {
                    return null;
                }

                if (res.CustomerName) {
                    self.account.setCustomerName(res.CustomerName);
                }

                if(self.activeOrder && self.activeOrder.OrderGuid !== res.ActiveOrderGuid){
                    self.clearActiveOrder();
                }
                
                if (res.Orders) {
                    await self.setOrders(res.Orders);
                }
                if (res.Addresses) {
                    await self.setAddresses(res.Addresses);
                }

                //await self.connectSignalR();


                //self.clearActiveOrder();
                //self.setOrders(res.Orders);
                //console.log("fetchOrders>", self.Orders.toJSON());
                
                // Todo: read OrderGuid from localstorage and set if res.Orders contains id
                
                if (res.ActiveOrderGuid) {
                    self.getActiveOrder(res.ActiveOrderGuid);
                }
                else
                {
                    self.clearActiveOrder();
                }
            },


            async getOrder(orderGuid, setActive = false) {
                //self.activeOrder = null;

                const res = await self.request("/Umbraco/Api/ActorOrder/Get",
                    {
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode,
                        OrderGuid: orderGuid,
                        ConnectionId: self.connection.id
                    });

                //console.debug("getOrder", res);
                self.applyOrder(res, orderGuid);
                if (setActive) {
                    self.setActiveOrder(orderGuid);
                }
            },

            async getBasket() {
                //self.activeOrder = null;
                const params = self.navigation.getParsedQueryString();
                const res = await self.request("/Umbraco/Api/ActorOrder/GetBasket",
                    {
                        BasketRequest: self.useBasket,
                        CultureCode: self.navigation.CultureCode,
                        MarketCode: self.navigation.MarketCode,
                        CountryCode: self.navigation.CountryCode,
                        CustomerId: null,
                        OrderGuid: null,
                        ConnectionId: self.connection && self.connection.id
                    });

                //console.debug("getOrder", res);
                self.setBasket(res);
            },

            applyOrder(order, orderGuid) {
                const orderIndex = self.Orders.findIndex(x => x.OrderGuid === orderGuid);
                if (orderIndex > -1) {
                    //    console.log("applyOrder", self.Orders[orderIndex]);
                    applySnapshot(self.Orders[orderIndex], order);
                    return self.Orders[orderIndex];
                }

                // ensure correct prices after active order is set, f5 on pre-season can otherwise return n/a prices
                //self.navigation.GetContent("set order");
            },


            async getOrderTemplates(siteId) {
                // Collect dates from server
                const res = await self.request("/Umbraco/Api/ActorOrder/GetOrderData",
                    {
                        CustomerId: self.navigation.getCustomerId(),
                        SiteId: siteId ? siteId : self.navigation.SiteId,
                        Parameters: {
                            CustomerId: self.navigation.getCustomerId(),
                            Action: "getOrderTemplates",
                            SiteId: siteId ? siteId : self.navigation.SiteId
                        }
                    });
                return res;
            },

            async addOrder(siteId) {

                console.debug("addOrder", self.navigation.getCustomerId());
                const res = await self.request("/Umbraco/Api/ActorOrder/Add",
                    {
                        CustomerId: self.navigation.getCustomerId(),
                        SiteId: siteId ? siteId : self.navigation.SiteId,
                        CultureCode: self.navigation.CultureCode,
                        CountryCode: self.navigation.CountryCode,

                    });

                if (res.status && res.status === "error") {
                    throw res;
                }

                self.setOrders(res.Orders);
                self.getActiveOrder(res.ActiveOrderGuid);


                return res;
            },
            async addNewAddress(address) {
                console.debug("addNewAddress", self.navigation.getCustomerId());
                const res = await self.request("/Umbraco/Api/ActorOrder/AddNewAddress",
                    {
                        CustomerId: self.navigation.getCustomerId(),
                        SiteId: self.navigation.SiteId,
                        FirstName: address.FirstName,
                        LastName: address.LastName,
                        EmailAddress: address.EmailAddress,
                        MobilePhoneNumber: address.MobilePhoneNumber,
                        PhoneNumber: address.PhoneNumber,
                        Line1: address.Line1,
                        Line2: address.Line2,
                        PostalCode: address.PostalCode,
                        City: address.City,
                        CountryName: address.CountryName,
                        CountryISOCode: address.CountryISOCode,
                        AddressName: address.AddressName,
                        CompanyName: address.CompanyName
                    });

                if (res.status && res.status === "error") {
                    throw res;
                }

                self.fetchOrders();
            },

            async deleteOrder(siteId, orderGuid) {
                console.debug("deleteOrder", self.navigation.getCustomerId(), orderGuid);
                const res = await self.request("/Umbraco/Api/ActorOrder/Delete",
                    {
                        CustomerId: self.navigation.getCustomerId(),
                        CultureCode: self.navigation.CultureCode,
                        SiteId: siteId ? siteId : self.navigation.SiteId,
                        OrderGuid: orderGuid
                    });

                if (res.status && res.status === "error") {
                    throw res;
                }

                self.clearActiveOrder();
                self.setOrders(res.Orders);
                if (res.ActiveOrderGuid) {
                    await self.getActiveOrder(res.ActiveOrderGuid);
                }
            },


            clearActiveOrder() {
                //await self.fetchOrders();
                self.activeOrder = null;
            },

            async getActiveOrder(orderGuid) {
                console.debug("getActiveOrder", orderGuid);
                await self.getOrder(orderGuid, true);

            },

            async setActiveOrder(orderGuid) {
                self.activeOrder = self.Orders.find(x => x.OrderGuid === orderGuid);
            },

            clearBasket() {
                self.activeOrder = null;
                self.Basket = null;
            },

            setBasket(basket) {
                if (!self.useBasket) return;

                if (!basket) return;

                if (self.Basket === null || self.Basket.OrderGuid !== basket.OrderGuid) {
                    self.activeOrder = null;
                    self.Basket = basket;
                }

                applySnapshot(self.Basket, basket);

                self.activeOrder = self.Basket;
            },

            async increaseQuantities(changes) {
                //self.Updating = true;

                // Update existing orderlines
                changes.forEach(change => {

                    let orderLine = null;

                    const productLines = self.activeOrder && self.activeOrder.ProductList.filter(product => product.Sku === change.Sku);

                    if (productLines && change.VariantSku) {
                        for (let pL of productLines) {
                            for (let oL of pL.OrderLines) {
                                if (oL.VariantSku === change.VariantSku) {
                                    orderLine = oL;
                                    break;
                                }
                            }
                        }
                    } else if (productLines) { // Sku
                        for (let pL of productLines) {
                            for (let oL of pL.OrderLines) {
                                if (oL.Sku === change.Sku) {
                                    orderLine = oL;
                                    break;
                                }
                            }
                        }
                    }


                    let addQuantity = Number.parseInt(change.AddQuantity);
                    if (Number.isNaN(addQuantity)) {
                        change.AddQuantity = 0;
                    } else {
                        change.AddQuantity = addQuantity;
                    }


                    if (orderLine && change.AddQuantity) {
                        const tempResult = orderLine.Quantity + change.AddQuantity;
                        orderLine.Quantity += change.AddQuantity;

                        if (orderLine.Quantity < 0) {
                            orderLine.Quantity = 0;
                            change.AddQuantity -= tempResult;
                        }

                        change.OriginalQuantity = orderLine.Quantity;

                    } else if (orderLine && change.Quantity) {
                        if (change.Quantity < 0) {
                            change.Quantity = 0;
                        }

                        change.AddQuantity = change.Quantity - orderLine.Quantity;
                    } else {
                        if (change.AddQuantity < 0) {
                            change.AddQuantity = 0;
                        }
                        change.OriginalQuantity = change.AddQuantity;
                        change.NewProduct = true;
                    }

                });

                return await self.updateQuantities(changes);
            },

            async updateQuantities(changes, options = null) {
                const recalcPayment = self.navigation.TemplateAlias === "IComCheckout";
                const oldOrderLines = new Map();
                
                changes.forEach(change => {
                    let orderLine = self.activeOrder && self.activeOrder.OrderLineById(change.OrderLineId);
                    if (!orderLine) {
                        const orderLinesBySku = self.activeOrder && self.activeOrder.OrderLinesBySku(change.Sku, change.VariantSku);
                        if (orderLinesBySku && orderLinesBySku.length > 0) {
                            orderLine = orderLinesBySku[0];
                        }
                    }
                    
                    let parsedNumber = Number.parseInt(change.OriginalQuantity);

                    if (orderLine) {
                        oldOrderLines.set(change, { ...orderLine });

                        if (Number.isNaN(parsedNumber)) {
                            parsedNumber = 0;
                        }
                        orderLine.SetOriginalQuantity(parsedNumber);
                        orderLine.Quantity = parsedNumber;
                        
                    }

                    change.Quantity = change.OriginalQuantity;
                    

                });

                const updateQuantitiesOptions = options && { Import: options.import, Commit: options.commit };

                const updateRequest = {
                    SiteId: self.navigation.SiteId,//siteId ? siteId : self.navigation.SiteId,
                    CultureCode: self.navigation.CultureCode,
                    MarketCode: self.navigation.MarketCode,
                    CountryCode: self.navigation.CountryCode,
                    RecalcPayment: recalcPayment, // checkoutTemplate open ? 
                    BasketRequest: self.useBasket,
                    OrderGuid: self.useBasket
                        ? null
                        : (self.activeOrder ? self.activeOrder.OrderGuid : null),
                    changes: changes, //[{Sku:'1234', VariantSku: null, Quantity:5},{}..]
                    CustomerId: self.navigation.getCustomerId(),
                    ConnectionId: self.connection ? self.connection.id : null,
                    Options: updateQuantitiesOptions
                };

                const res = await self.request("/Umbraco/Api/ActorOrder/UpdateQuantities",
                    updateRequest);

                if (res.status && res.status === "error") {
                    throw res;
                }

                if (!self.activeOrder && res.ActiveOrderGuid && res.Orders) {
                    await self.setOrders(res.Orders);
                    await self.setActiveOrder(res.ActiveOrderGuid);
                }

                if (self.useBasket && res && res.BasketGuid) {
                    self.setBasket(res);
                }

                // Handle added products
                if (self.analytics) { // This can be moved up to before we update our orders based on res.Orders to avoid the need of using oldOrderLines
                    changes.forEach(change => {

                        let orderLine, delta;
                        const oldOrderLine = oldOrderLines.get(change);
                        if (oldOrderLine) {
                            delta = change.Quantity - oldOrderLine.Quantity;
                            orderLine = oldOrderLine; // Use the saved order line, retrieving from the basket won't work if quantity changed to 0
                        } else {
                            orderLine = self.activeOrder && self.activeOrder.OrderLineById(change.OrderLineId);
                            if (!orderLine) {
                                const orderLinesBySku = self.activeOrder && self.activeOrder.OrderLinesBySku(change.Sku, change.VariantSku);
                                if (orderLinesBySku && orderLinesBySku.length > 0) {
                                    orderLine = orderLinesBySku[0];
                                }
                            }
                            delta = change.Quantity;
                        }

                        if (orderLine) {
                            const addEvent = {
                                CurrencyCode: self.activeOrder.CurrencyCode,
                                ProductName: orderLine.ProductName,
                                VariantName: orderLine.VariantName,
                                Sku: orderLine.Sku,
                                VariantSku: orderLine.VariantSku,
                                Quantity: Math.abs(delta),
                                // orderLine.PriceFormatted is formatted, so make sure it's compatible with what Google wants
                                PriceFloatingPoint: orderLine.Price,
                                DiscountFloatingPoint: orderLine.UnitDiscount
                            }
                            if (delta < 0) {
                                self.analytics.removeFromCart(addEvent);
                            } else if (delta > 0) {
                                self.analytics.addToCart(addEvent);
                            }
                        }
                    });
                }
 
                return res;
            },

            async update(values) {

                const orderGuid = self.activeOrder ? self.activeOrder.OrderGuid : null;
                const recalcPayment = self.navigation.TemplateAlias === "IComCheckout";


                const updateRequest = {
                    SiteId: self.navigation.SiteId,
                    CultureCode: self.navigation.CultureCode,
                    MarketCode: self.navigation.MarketCode,

                    RecalcPayment: recalcPayment, // checkoutTemplate open ? 
                    OrderGuid: self.useBasket ? null : orderGuid,
                    BasketRequest: self.useBasket,
                    CustomerId: self.navigation.getCustomerId(),
                    ConnectionId: self.connection ? self.connection.id : null,
                    PaymentMethodId: values.paymentMethod ? values.paymentMethod.PaymentMethodId : null,
                    ShippingMethodId: values.shippingMethod ? values.shippingMethod.ShippingMethodId : null,
                    CountryCode: values.countryISOCode ? values.countryISOCode : self.navigation.CountryCode,
                    BillingAddress: values.billingAddress,
                    ShippingAddress: values.shippingAddress,
                    AdditionalData: values.additionalData,
                    Pay: values.pay,
                    Note: values.note,
                    TermsAccepted: values.termsAccepted
                };

                const res = await self.request("/Umbraco/Api/ActorOrder/HandleCheckout",
                    updateRequest);

                if (self.useBasket && res && res.BasketGuid) {

                    self.setBasket(res);
                }

                return res;
            },


            async getConfirmation(orderGuid) {
                const res = await self.request("/Umbraco/Api/ActorOrder/GetConfirmation",
                    {
                        CultureCode: self.navigation.CultureCode,
                        OrderGuid: orderGuid
                    });

                if (res.status && res.status === "error") {
                    throw res;
                }
                //console.log("GetConfirmation", res);
                return res;
            },


            async getProduct(sku, cancelToken) {
                console.debug("pageContent", self.navigation.pageContent);
                const res = await self.request("/Umbraco/Api/Content/GetProduct",
                    {
                        Sku: sku,
                        CustomerId: self.navigation.CustomerId,
                        SiteId: self.navigation.SiteId,
                        MarketCode: self.navigation.MarketCode,
                        CultureCode: self.navigation.CultureCode,
                        CountryCode: self.navigation.CountryCode,
                        OrderGuid: self.activeOrder ? self.activeOrder.OrderGuid : "" // optional

                    },
                    {
                        cancelToken: cancelToken
                    });


                if (res.status && res.status === "ok" && res.product) {
                    return res;
                } else if (res.status && res.status === "ok") {
                    return null;
                } else if (res.status && res.status === "error") {

                    throw res;
                }

            },


            async getOrderForecastDate(orderGuid) {
                const res = await self.request("/Umbraco/Api/ActorOrder/GetForecast",
                    // todo: StockAlias should not be set here
                    {CustomerId: self.navigation.CustomerId, OrderGuid: orderGuid, StockAlias: "B2B"});
                return res;
            },

            async request(path, query = {}, options) {
                const res = await axios.post(`${path}`, query, options);
                return res.data;
            }
        };

    });

